export default "__VITE_ASSET__1ebfda38__"